//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.exams;
//  -- Examples array selector --------



export const useExams = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}